import * as $echarts from "echarts";
import { specialStyle } from "@/assets/utils/specialStyle";
import * as size from "../utils/chartSize";

const commonGaugeCharts = function (params) {
    const chartSizeA = specialStyle(document.body.clientHeight, 12)
    const chartSizeB = specialStyle(document.body.clientHeight, 14)
    const chartSizeC = specialStyle(document.body.clientHeight, 16)
    const chartSizeD = specialStyle(document.body.clientHeight, 18)
    const chartSizeE = specialStyle(document.body.clientHeight, 20)
    const chartSizeF = specialStyle(document.body.clientHeight, 22)
    const chartSizeG = specialStyle(document.body.clientHeight, 24)
    const chartSizeH = specialStyle(document.body.clientHeight, 28)
    const chartSizeI = specialStyle(document.body.clientHeight, 30)
    const chartSizeJ = specialStyle(document.body.clientHeight, 40)
    const chartSizeK = specialStyle(document.body.clientHeight, 50)
    // 特殊
    const chartSizeL = specialStyle(document.body.clientHeight, 4)
    const chartSizeM = specialStyle(document.body.clientHeight, 6)
    const chartSizeN = specialStyle(document.body.clientHeight, 10)
    const chartSizeO = specialStyle(document.body.clientHeight, 34)
    const chartSizeP = specialStyle(document.body.clientHeight, 60)
    const chartSizeQ = specialStyle(document.body.clientHeight, 85)

    let colorA = {
        x: 0, y: 1, x2: 0, y2: 0,
        colorStops: [
            { offset: 0, color: 'rgba(50, 197, 255, 0)' },
            { offset: 0.2, color: 'rgba(50, 197, 255, .3)' },
            { offset: 1, color: 'rgba(50, 197, 255, .8)' }
        ]
    }

    let colorB = {
        x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [
            { offset: 0, color: "rgba(255,255,255,1)" },
            { offset: 1, color: "rgba(255,255,255,0)" }
        ],
        global: false
    }

    // let colorC = "#32C5FF"

    let colorC = {
        x: 0, y: 0, x2: 1, y2: 0,
        colorStops: [
            { offset: 0, color: "#32C5FF" },
            { offset: 1, color: "#32C5FF" }
        ],
        global: false
    }

    // 绘制图表
    let option = {
        tooltip: {
            backgroundColor: '#000',
            color: '#000',
            trigger: 'axis',
            axisPointer: {
                // 文字样式
                label: {
                    precision: 2, // 小数点精度
                },
                // 线样式
                lineStyle: {},
            },
            //浮层的文本样式
            textStyle: {
                fontSize: chartSizeB,
                fontFamily: 'Microsoft YaHei',
            },
            formatter: "{a} <br/>{b} : {c}%"
        },
        grid: {
            left: chartSizeJ,
            top: chartSizeJ,
            bottom: chartSizeI,
            right: chartSizeE,
        },
        series: [
            // 第一大圆
            {
                name: "内部进度条",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '84%',
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / 100, colorC],
                            [1, colorC]
                        ],
                        width: 2
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    color: "#ffffff"
                },
                detail: {
                    show: false,
                },
                title: { //标题
                    show: false,
                },
                data: [{
                    name: "",
                    value: params.num,
                }],
                pointer: {
                    show: true,
                    length: '70%',
                    radius: '20%',
                    width: 3 //指针粗细
                },
                animationDuration: 4000,
            },
            // 刻度 + 数值
            {
                name: '外部刻度',
                type: 'gauge',
                center: ['50%', '55%'],
                radius: '76%',
                min: 0, //最小刻度
                max: 100, //最大刻度
                splitNumber: 5, //刻度数量
                startAngle: 225,
                endAngle: -45,
                axisLine: {
                    show: true,
                    lineStyle: {
                        width: 1,
                        color: [[1, 'rgba(0,0,0,0)']]
                    }
                }, //仪表盘轴线
                axisLabel: {
                    show: true,
                    color: '#ffffff',
                    fontSize: chartSizeC,
                    fontFamily: 'Microsoft YaHei',
                    distance: -chartSizeO,
                    formatter: function (v) {
                        switch (v + '') {
                            case '0':
                                return '0';
                            case '10':
                                return '10';
                            case '20':
                                return '20';
                            case '30':
                                return '30';
                            case '40':
                                return '40';
                            case '50':
                                return '50';
                            case '60':
                                return '60';
                            case '70':
                                return '70';
                            case '80':
                                return '80';
                            case '90':
                                return '90';
                            case '100':
                                return '100';
                        }
                    }
                }, //刻度标签。
                axisTick: {
                    show: true,
                    splitNumber: 3,
                    lineStyle: {
                        color: colorB,
                        width: 1,
                    },
                    length: -chartSizeL
                }, //刻度样式
                splitLine: {
                    show: true,
                    length: 0,
                    lineStyle: {
                        color: colorB,
                        width: 1,
                    }
                }, //分隔线样式
                detail: {
                    show: false
                }
            },
            // 第二大圆
            {
                name: "内部小圆",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '68%',
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / 100, colorC],
                            [1, "rgba(0,0,0,0)"]
                        ],
                        width: chartSizeM
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    show: false,
                },
            },
            // 渐变色
            {
                name: "内部阴影",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '62%',
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [[params.num / 100, colorA], [1, 'rgba(28,128,245,0)']],
                        width: chartSizeI
                    },
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    show: false,
                },

            },
            // 第三大圆
            {
                name: "内部进度条",
                type: "gauge",
                center: ['50%', '55%'],
                radius: '36%',
                splitNumber: chartSizeN,
                axisLine: {
                    lineStyle: {
                        color: [
                            [params.num / 100, colorC],
                            [1, colorC]
                        ],
                        width: 1
                    }
                },
                axisLabel: {
                    show: false,
                },
                axisTick: {
                    show: false,

                },
                splitLine: {
                    show: false,
                },
                itemStyle: {
                    color: "#ffffff"
                },
                detail: {
                    formatter: function (value) {
                        if (value !== 0) {
                            var num = Math.round(value);
                            return parseInt(num).toFixed(0) + "%";
                        } else {
                            return 0;
                        }
                    },
                    offsetCenter: [0, chartSizeQ],
                    textStyle: {
                        padding: [0, 0, 0, 0],
                        fontSize: chartSizeD,
                        fontWeight: 500,
                        fontFamily: 'Microsoft YaHei',
                        color: "#FFF"
                    },
                },
                title: { //标题
                    show: true,
                    offsetCenter: [0, chartSizeP], // x, y，单位px
                    textStyle: {
                        color: "#FFF",
                        fontSize: chartSizeB, //表盘上的标题文字大小
                        fontWeight: 400,
                        fontFamily: 'Microsoft YaHei',
                    }
                },
                data: [{
                    name: "生产效率",
                    value: params.num,
                    
                }],
                pointer: {
                    show: true,
                    length: '70%',
                    radius: '20%',
                    width: 3 //指针粗细

                },
                animationDuration: 4000,
            },
            // 指针上的圆
            {
                type: 'pie',
                tooltip: {
                    show: false
                },
                hoverAnimation: false,
                legendHoverLink: false,
                radius: ['0%', '6%'],
                center: ['50%', '55%'],
                label: {
                    normal: {
                        show: false
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: [{
                    value: 120,
                    itemStyle: {
                        normal: {
                            color: "#ffffff",
                        },
                    }
                }]
            }
        ]
    }
    params.id.setOption(option, true)
}

export {
    commonGaugeCharts,
}